import IconHOC from '../IconHOC';

import { ReactComponent as XIcon } from './x.svg';

export const X = IconHOC(XIcon);
